import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// Connects to data-controller="todo"
export default class extends Controller {
  static values = {
    url: String
  }

  do(event) {
    if (event.currentTarget.checked) {
      post(this.urlValue, {
        headers: {
          Accept: "text/vnd.turbo-stream.html"
        }
      })
    }
  }
}
